/**
 * What the sign-in card calls itself, given where somebody was trying to go.
 *
 * WHY IT IS NOT READ FROM SETTINGS. Every other title in this app comes from Firestore, and this
 * one cannot: the person is not signed in yet, and the rules — correctly — refuse an unauthenticated
 * read. So these are constants, and they are the only titles in the app that are.
 *
 * WHY IT MATTERS. The card said "New Matter Intake" to somebody who had followed a link to the
 * conflicts page. It is the first thing they see and the only thing telling them they are in the
 * right place; naming a different tool reads like a wrong link.
 *
 * Kept deliberately close to the shipped names of those pages. A firm that renames the conflicts
 * page in settings will see the new name everywhere except here, which is a smaller wrong than
 * announcing the wrong tool.
 */

const BY_PREFIX = [
  ['/conflicts', 'Conflict check request'],
  ['/ccc', 'Candidate conflict checks'],
  ['/apply', 'Applications for employment'],
  ['/admin', 'Administration'],
];

const DEFAULT_TITLE = 'New Matter Intake';

/**
 * @param {string} pathname  window.location.pathname
 * @returns {string}
 */
export function signInTitleFor(pathname) {
  const path = String(pathname || '/');
  // Longest prefix first, so a future '/conflicts-something' cannot be claimed by '/conflicts'
  // unless it genuinely is one.
  const match = [...BY_PREFIX]
    .sort((a, b) => b[0].length - a[0].length)
    .find(([prefix]) => path === prefix || path.startsWith(`${prefix}/`));
  return match ? match[1] : DEFAULT_TITLE;
}

export { BY_PREFIX, DEFAULT_TITLE };
